import api from "api";
import { useMutation } from "react-query";
import { z } from "zod";

export const ClinicPartnerPayloadSchema = z.object({
  email: z.string().email("errors.invalid_email").min(1, "errors.required"),
  phone_number: z.string().optional(),
  phone_country_code: z.string().optional(),
  first_name: z.string().min(1, "errors.required"),
  last_name: z.string().min(1, "errors.required"),
  payer_ids: z.array(z.number()).min(1, "errors.required"),
});
export type ClinicPartnerPayload = z.infer<typeof ClinicPartnerPayloadSchema>;

const OP = "POST /invitations/clinic_partner";

const useInvitePartner = () =>
  useMutation((data: ClinicPartnerPayload) => {
    // @ts-ignore
    return api.parse(OP, { data });
  });

export default useInvitePartner;
